import React from "react";
import StyledMessage from "components/ui/StyledMessage";
import { useUser } from "components/hooks/useUser";

export function CAEnrollmentAckMessage() {
  const {
    messages: { calgrantEnrollmentAcknowledgement: message },
  } = useUser((user) => user.enrollmentResources);

  return (
    <StyledMessage data-testid="ca-enrollment-acknowledgement-message">
      <div dangerouslySetInnerHTML={{ __html: message.descrlong }} />
    </StyledMessage>
  );
}

CAEnrollmentAckMessage.displayName = "CAEnrollmentAckMessage";
